// extracted by mini-css-extract-plugin
module.exports = {"sticky-phone-bubble-container":"StickyPhoneBubble_sticky-phone-bubble-container__Mm78W","show":"StickyPhoneBubble_show__CWVGV"};